module.exports = __webpack_public_path__ + "img/download_but2.37b00ade.png";